import { useState, useCallback } from 'react'

export type DisplayGraph = {
  displayScheduleGraph: boolean
  displayActualAndProspectGraph: boolean
  displaySimulatedGraph: boolean
  displayIdealGraph: boolean
}
export type ToggleDisplayGraph = {
  toggleDisplayScheduleGraph: () => void
  toggleDisplayActualAndProspectGraph: () => void
  toggleDisplaySimulatedGraph: () => void
  toggleDisplayIdealGraph: () => void
}
export const useDisplayGraph = (): DisplayGraph & ToggleDisplayGraph => {
  const [displayScheduleGraph, setDisplayScheduleGraph] =
    useState<boolean>(true)
  const toggleDisplayScheduleGraph = useCallback(
    () => setDisplayScheduleGraph(prev => !prev),
    []
  )
  const [displayActualAndProspectGraph, setDisplayActualAndProspectGraph] =
    useState<boolean>(true)
  const toggleDisplayActualAndProspectGraph = useCallback(
    () => setDisplayActualAndProspectGraph(prev => !prev),
    []
  )
  // デモ環境ではリソース線を非表示から始める（task#VF0TPUHB）。
  // デモ以外のビルド（本番・ステージング・開発）では従来どおり表示から始める。
  const [displaySimulatedGraph, setDisplaySimulatedGraph] = useState<boolean>(
    process.env.FLAGXS_DEMO_MODE !== 'true'
  )
  const toggleDisplaySimulatedGraph = useCallback(
    () => setDisplaySimulatedGraph(prev => !prev),
    []
  )
  const [displayIdealGraph, setDisplayIdealGraph] = useState<boolean>(true)
  const toggleDisplayIdealGraph = useCallback(
    () => setDisplayIdealGraph(prev => !prev),
    []
  )
  return {
    displayScheduleGraph,
    toggleDisplayScheduleGraph,
    displayActualAndProspectGraph,
    toggleDisplayActualAndProspectGraph,
    displaySimulatedGraph,
    toggleDisplaySimulatedGraph,
    displayIdealGraph,
    toggleDisplayIdealGraph,
  }
}
